var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "remove-trusted-device",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__("popups.RemoveTrustedDevice.delete_your_trusted_device")
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__default" },
              [
                _c(
                  "div",
                  { staticClass: "device typographies-paragraph-medium-bold" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.trustedDevice.device) +
                        " - " +
                        _vm._s(_vm.trustedDevice.browser) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "typographies-paragraph-medium-semibold m-0 mb-3"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "En supprimant cet appareil de confiance, un code de sécurité vous sera à nouveau demandé à chaque connexion sur cet appareil."
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.disconnect,
                      callback: function($$v) {
                        _vm.disconnect = $$v
                      },
                      expression: "disconnect"
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Me déconnecter immédiatement de cet appareil"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: { click: _vm.close }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-2",
                  attrs: {
                    label: _vm.$t.__(
                      "popups.RemoveTrustedDevice.delete_trusted_device"
                    ),
                    type: "primary-destructive",
                    loading: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }